import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function FreeToPaid({data}){

    const find = c => {
        const item = data.find(i => i.category === c);
        return parseFloat(item?.ratio || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Conversions Offert/Payant</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Tx de conversion</TableCell>
                        <TableCell>{find('dentaire')} %</TableCell>
                        <TableCell>{find('kine')} %</TableCell>
                        <TableCell>{find('medecine')} %</TableCell>
                        <TableCell>{find('pharma')} %</TableCell>
                        <TableCell>{find('sante-mentale')} %</TableCell>
                        <TableCell>{find('infirmiere')} %</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}